import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dd963900"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col h-full gap-4 px-8 overflow-auto text-black" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Scenario Report", -1))
const _hoisted_3 = { class: "subtitle text-military-green-500" }
const _hoisted_4 = { class: "pretitle overall-results" }
const _hoisted_5 = { class: "task-results" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "mb-4 overflow-y-scroll" }
const _hoisted_9 = { class: "text-military-green-500 pretitle" }
const _hoisted_10 = { class: "mb-4" }
const _hoisted_11 = { class: "font-bold underline text-md text-rust-500" }

import IconComponent from '../icon/IconComponent.vue';
import Icon from '../icon/Icon';
import RecursiveThing from './RecursiveChecklistReportComponent.vue';
import { ScenarioDeserializedThing } from '../../ecs/types';
import {
  formatTimestamp_DD_MM_YY_SLASHES,
  secondsToMinutesObject,
  formatTime
} from '../../utils/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'ScenarioReportComponent',
  props: {
    scenario: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(formatTimestamp_DD_MM_YY_SLASHES)(__props.scenario.completedAt)) + " @ " + _toDisplayString(_unref(formatTime)(__props.scenario.completedAt.toDate(), false)), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("p", null, " Time Spent: " + _toDisplayString(_unref(secondsToMinutesObject)(__props.scenario.history.timeSpent / 1000).minutes) + ":" + _toDisplayString(_unref(secondsToMinutesObject)(__props.scenario.history.timeSpent / 1000).seconds), 1),
      _createElementVNode("p", null, " Points Earned: " + _toDisplayString(__props.scenario.history.pointsEarned) + "/" + _toDisplayString(__props.scenario.history.totalPointsPossible), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(IconComponent, {
          class: "mr-2",
          icon: _unref(Icon).GREEN_CHECKBOX
        }, null, 8, ["icon"]),
        _createElementVNode("p", null, " Full Points: " + _toDisplayString(__props.scenario.history.checklistCount.total -
            __props.scenario.history.checklistCount.compromisedCount), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(IconComponent, {
          class: "mr-2",
          icon: _unref(Icon).RUST_CHECKBOX
        }, null, 8, ["icon"]),
        _createElementVNode("p", null, " Half Points: " + _toDisplayString(__props.scenario.history.checklistCount.compromisedCount), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.scenario.history.modules, (module, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createElementVNode("p", _hoisted_9, _toDisplayString(module.description.title), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(module.checklists.filter(
            (checklist) => checklist.complete
          ), (checklist, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "text-military-green-500"
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("p", _hoisted_11, _toDisplayString(checklist.description.title), 1),
                _createVNode(RecursiveThing, { checklist: checklist }, null, 8, ["checklist"])
              ])
            ]))
          }), 128))
        ]))
      }), 128))
    ])
  ]))
}
}

})